/* RAPTIC global behaviors: hover-open mega menu (desktop). */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var HOVER = window.matchMedia('(hover: hover)');
  var CLOSE_DELAY = 180;

  function initMegaMenuHover() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
      var details = menu.querySelector('details');
      var summary = menu.querySelector('summary');
      if (!details || !summary || details.dataset.rapticHover) return;
      details.dataset.rapticHover = 'true';

      var closeTimer = null;

      function open() {
        if (!DESKTOP.matches || !HOVER.matches) return;
        clearTimeout(closeTimer);
        // Close any sibling menus first
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (d) {
          if (d !== details) close(d);
        });
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }

      function close(el) {
        var target = el && el.tagName ? el : details;
        target.removeAttribute('open');
        var s = target.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'false');
      }

      function scheduleClose() {
        if (!DESKTOP.matches || !HOVER.matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          close();
        }, CLOSE_DELAY);
      }

      menu.addEventListener('mouseenter', open);
      menu.addEventListener('mouseleave', scheduleClose);

      // Hovering onto the panel itself keeps it open
      var content = details.querySelector('.mega-menu__content');
      if (content) {
        content.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
        });
        content.addEventListener('mouseleave', scheduleClose);
      }

      // Escape closes
      details.addEventListener('keyup', function (event) {
        if (event.key === 'Escape') close();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuHover);
  } else {
    initMegaMenuHover();
  }

  // Re-init when the theme editor reloads sections
  document.addEventListener('shopify:section:load', initMegaMenuHover);
})();
